<template>
  <div>
    <div class="venture" v-for="v in ventures" :key="v.id">
      <div class="media">
        <div class="media-left">
          <img :src="`/storage/${v.logo}`" alt="" class="logo" />
        </div>
        <div class="media-body">
          <div class="controls">
            <router-link :to="`/ventures/${v.id}/edit`"
              ><img src="@/assets/images/edit.svg" alt=""
            /></router-link>
            <a href="#" @click.prevent="deleteVenture(v.id)"
              ><img src="@/assets/images/delete.svg" alt=""
            /></a>
          </div>
          <div class="tags is-hidden-mobile">
            <router-link
              v-for="c in v.categories"
              :key="c.id"
              :to="`/categories/${c.id}/ventures`"
              class="tag is-rounded is-primary"
            >
              {{ c.name }}
            </router-link>
          </div>
          <div class="name">{{ v.name }}</div>
          <div class="validated">
            <div v-if="v.published">
              <span class="icon"
                ><img src="@/assets/images/check-circle.svg" alt=""
              /></span>
              <span>Publicado</span>
            </div>
            <div v-else>
              <span class="icon"
                ><img src="@/assets/images/warning.svg" alt=""
              /></span>
              <span>En revisión</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<style lang="scss" scoped>
.venture {
  border: 1px solid #e3e3e3;
  margin-bottom: 20px;
  border-radius: 4px;
  position: relative;
  .media {
    .media-left {
      padding: 24px;
      .logo {
        width: 64px;
        height: 64px;
        min-width: 64px;
        min-height: 64px;
      }
    }
    .media-body {
      padding: 24px;
      border-left: 1px solid #e3e3e3;

      .controls {
        position: absolute;
        top: 24px;
        right: 24px;
      }
      .name {
        font-size: (32rem/16);
        font-weight: bold;
      }
      .validated {
        font-size: 1rem;
      }
    }
  }
}
</style>
<script>
import axios from "axios";

export default {
  data() {
    return {
      ventures: []
    };
  },
  props: {
    limit: { type: Number, default: null }
  },
  created() {
    this.refreshVentures();
  },
  methods: {
    refreshVentures() {
      axios
        .get("/api/user/ventures", {
          params: {
            limit: this.limit || undefined
          },
          headers: {
            Authorization: `Bearer ${this.$store.state.accessToken}`
          }
        })
        .then(response => {
          this.ventures = response.data;
        });
    },
    deleteVenture(index) {
      if (window.confirm("¿Esta seguro que desea eliminar?")) {
        axios
          .delete(`/api/ventures/${index}`, {
            headers: {
              Authorization: `Bearer ${this.$store.state.accessToken}`
            }
          })
          .then(() => {
            this.refreshVentures();
          });
      }
    }
  }
};
</script>